import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'layout-confirm-popup',
  imports: [],
  templateUrl: './confirm-popup.component.html',
  styleUrl: './confirm-popup.component.scss'
})
export class ConfirmPopupComponent {
  @Input() title: string = "Title";
  @Input() cancelText: string = "Cancel";
  @Input() confirmText: string = "Confirm";

  @Output() onCancel: EventEmitter<any> = new EventEmitter();
  @Output() onSubmit: EventEmitter<any> = new EventEmitter();

  onCancelCall() {
    this.onCancel.emit();
  }

  onConfirmCall() {
    this.onSubmit.emit();
  }
}
